//# sourceMappingURL=events.mjs.map
/// <reference types="./events.d.mts" />
import * as $event from "../../../redraw/redraw/event.mjs";
import * as $attribute from "../../redraw/dom/attribute.mjs";
import * as $animation from "../../redraw/dom/event/animation.mjs";
import * as $clipboard from "../../redraw/dom/event/clipboard.mjs";
import * as $composition from "../../redraw/dom/event/composition.mjs";
import * as $drag from "../../redraw/dom/event/drag.mjs";
import * as $focus from "../../redraw/dom/event/focus.mjs";
import * as $input from "../../redraw/dom/event/input.mjs";
import * as $keyboard from "../../redraw/dom/event/keyboard.mjs";
import * as $mouse from "../../redraw/dom/event/mouse.mjs";
import * as $pointer from "../../redraw/dom/event/pointer.mjs";
import * as $touch from "../../redraw/dom/event/touch.mjs";
import * as $transition from "../../redraw/dom/event/transition.mjs";
import * as $wheel from "../../redraw/dom/event/wheel.mjs";

/**
 * `none` will not appear in HTML attributes. Use it for conditional rendering.
 */
export const none = $attribute.none;

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/animationend_event)
 */
export function on_animation_end(handler) {
  return $attribute.attribute("onAnimationEnd", handler);
}

/**
 * Alternative version of [`on_animation_end`](#on_animation_end) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/animationend_event)
 */
export function on_animation_end_capture(handler) {
  return $attribute.attribute("onAnimationEndCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/animationiteration_event)
 */
export function on_animation_iteration(handler) {
  return $attribute.attribute("onAnimationIteration", handler);
}

/**
 * Alternative version of [`on_animation_iteration`](#on_animation_iteration) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/animationiteration_event)
 */
export function on_animation_iteration_capture(handler) {
  return $attribute.attribute("onAnimationIterationCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/animationstart_event)
 */
export function on_animation_start(handler) {
  return $attribute.attribute("onAnimationStart", handler);
}

/**
 * Alternative version of [`on_animation_start`](#on_animation_start) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/animationstart_event)
 */
export function on_animation_start_capture(handler) {
  return $attribute.attribute("onAnimationStartCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/auxclick_event)
 */
export function on_aux_click(handler) {
  return $attribute.attribute("onAuxClick", handler);
}

/**
 * Alternative version of [`on_aux_click`](#on_aux_click) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/auxclick_event)
 */
export function on_aux_click_capture(handler) {
  return $attribute.attribute("onAuxClickCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/beforeinput_event)
 */
export function on_before_input(handler) {
  return $attribute.attribute("onBeforeInput", handler);
}

/**
 * Alternative version of [`on_before_input`](#on_before_input) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/beforeinput_event)
 */
export function on_before_input_capture(handler) {
  return $attribute.attribute("onBeforeInputCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/blur_event)
 */
export function on_blur(handler) {
  return $attribute.attribute("onBlur", handler);
}

/**
 * Alternative version of [`on_blur`](#on_blur) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/blur_event)
 */
export function on_blur_capture(handler) {
  return $attribute.attribute("onBlurCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Element/input_event)
 */
export function on_change(handler) {
  return $attribute.attribute("onChange", handler);
}

/**
 * Alternative version of [`on_change`](#on_change) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Element/input_event)
 */
export function on_change_capture(handler) {
  return $attribute.attribute("onChangeCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/click_event)
 */
export function on_click(handler) {
  return $attribute.attribute("onClick", handler);
}

/**
 * Alternative version of [`on_click`](#on_click) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/click_event)
 */
export function on_click_capture(handler) {
  return $attribute.attribute("onClickCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/compositionstart_event)
 */
export function on_composition_start(handler) {
  return $attribute.attribute("onCompositionStart", handler);
}

/**
 * Alternative version of [`on_composition_start`](#on_composition_start) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/compositionstart_event)
 */
export function on_composition_start_capture(handler) {
  return $attribute.attribute("onCompositionStartCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/compositionend_event)
 */
export function on_composition_end(handler) {
  return $attribute.attribute("onCompositionEnd", handler);
}

/**
 * Alternative version of [`on_composition_end`](#on_composition_end) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/compositionend_event)
 */
export function on_composition_end_capture(handler) {
  return $attribute.attribute("onCompositionEndCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/compositionupdate_event)
 */
export function on_composition_update(handler) {
  return $attribute.attribute("onCompositionUpdate", handler);
}

/**
 * Alternative version of [`on_composition_update`](#on_composition_update) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/compositionupdate_event)
 */
export function on_composition_update_capture(handler) {
  return $attribute.attribute("onCompositionUpdateCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/context_event)
 */
export function on_context_menu(handler) {
  return $attribute.attribute("onContextMenu", handler);
}

/**
 * Alternative version of [`on_context_menu`](#on_context_menu) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/context_event)
 */
export function on_context_menu_capture(handler) {
  return $attribute.attribute("onContextMenuCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/copy_event)
 */
export function on_copy(handler) {
  return $attribute.attribute("onCopy", handler);
}

/**
 * Alternative version of [`on_copy`](#on_copy) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/copy_event)
 */
export function on_copy_capture(handler) {
  return $attribute.attribute("onCopyCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/cut_event)
 */
export function on_cut(handler) {
  return $attribute.attribute("onCut", handler);
}

/**
 * Alternative version of [`on_cut`](#on_cut) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/cut_event)
 */
export function on_cut_capture(handler) {
  return $attribute.attribute("onCutCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/dblclick_event)
 */
export function on_double_click(handler) {
  return $attribute.attribute("onDoubleClick", handler);
}

/**
 * Alternative version of [`on_double_click`](#on_double_click) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/dblclick_event)
 */
export function on_double_click_capture(handler) {
  return $attribute.attribute("onDoubleClickCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/drag_event)
 */
export function on_drag(handler) {
  return $attribute.attribute("onDrag", handler);
}

/**
 * Alternative version of [`on_drag`](#on_drag) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/drag_event)
 */
export function on_drag_capture(handler) {
  return $attribute.attribute("onDragCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragend_event)
 */
export function on_drag_end(handler) {
  return $attribute.attribute("onDragEnd", handler);
}

/**
 * Alternative version of [`on_drag_end`](#on_drag_end) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragend_event)
 */
export function on_drag_end_capture(handler) {
  return $attribute.attribute("onDragEndCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragenter_event)
 */
export function on_drag_enter(handler) {
  return $attribute.attribute("onDragEnter", handler);
}

/**
 * Alternative version of [`on_drag_enter`](#on_drag_enter) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragenter_event)
 */
export function on_drag_enter_capture(handler) {
  return $attribute.attribute("onDragEnterCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragover_event)
 */
export function on_drag_over(handler) {
  return $attribute.attribute("onDragOver", handler);
}

/**
 * Alternative version of [`on_drag_over`](#on_drag_over) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragover_event)
 */
export function on_drag_over_capture(handler) {
  return $attribute.attribute("onDragOverCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragstart_event)
 */
export function on_drag_start(handler) {
  return $attribute.attribute("onDragStart", handler);
}

/**
 * Alternative version of [`on_drag_start`](#on_drag_start) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragstart_event)
 */
export function on_drag_start_capture(handler) {
  return $attribute.attribute("onDragStartCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragleave_event)
 */
export function on_drag_leave(handler) {
  return $attribute.attribute("onDragLeave", handler);
}

/**
 * Alternative version of [`on_drag_leave`](#on_drag_leave) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/HTMLElement/dragleave_event)
 */
export function on_drag_leave_capture(handler) {
  return $attribute.attribute("onDragLeaveCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/drop_event)
 */
export function on_drop(handler) {
  return $attribute.attribute("onDrop", handler);
}

/**
 * Alternative version of [`on_drop`](#on_drop) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/drop_event)
 */
export function on_drop_capture(handler) {
  return $attribute.attribute("onDropCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/focus_event)
 */
export function on_focus(handler) {
  return $attribute.attribute("onFocus", handler);
}

/**
 * Alternative version of [`on_focus`](#on_focus) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/focus_event)
 */
export function on_focus_capture(handler) {
  return $attribute.attribute("onFocusCapture", handler);
}

/**
 * Alternative version of [`on_got_pointer`](#on_got_pointer) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/gotpointercapture_event)
 */
export function on_got_pointer_capture(handler) {
  return $attribute.attribute("onGotPointerCapture", handler);
}

/**
 * Alternative version of [`on_got_pointer_capture`](#on_got_pointer_capture) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/gotpointercapture_event)
 */
export function on_got_pointer_capture_capture(handler) {
  return $attribute.attribute("onGotPointerCaptureCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Element/input_event)
 */
export function on_input(handler) {
  return $attribute.attribute("onInput", handler);
}

/**
 * Alternative version of [`on_input`](#on_input) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Element/input_event)
 */
export function on_input_capture(handler) {
  return $attribute.attribute("onInputCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/keydown_event)
 */
export function on_key_down(handler) {
  return $attribute.attribute("onKeyDown", handler);
}

/**
 * Alternative version of [`on_key_down`](#on_key_down) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/keydown_event)
 */
export function on_key_down_capture(handler) {
  return $attribute.attribute("onKeyDownCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/keypress_event)
 */
export function on_key_press(handler) {
  return $attribute.attribute("onKeyPress", handler);
}

/**
 * Alternative version of [`on_key_press`](#on_key_press) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/keypress_event)
 */
export function on_key_press_capture(handler) {
  return $attribute.attribute("onKeyPressCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/keyup_event)
 */
export function on_key_up(handler) {
  return $attribute.attribute("onKeyUp", handler);
}

/**
 * Alternative version of [`on_key_up`](#on_key_up) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/keyup_event)
 */
export function on_key_up_capture(handler) {
  return $attribute.attribute("onKeyUpCapture", handler);
}

/**
 * Alternative version of [`on_lost_pointer`](#on_lost_pointer) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/lostpointercapture_event)
 */
export function on_lost_pointer_capture(handler) {
  return $attribute.attribute("onLostPointerCapture", handler);
}

/**
 * Alternative version of [`on_lost_pointer_capture`](#on_lost_pointer_capture) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/lostpointercapture_event)
 */
export function on_lost_pointer_capture_capture(handler) {
  return $attribute.attribute("onLostPointerCaptureCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mousedown_event)
 */
export function on_mouse_down(handler) {
  return $attribute.attribute("onMouseDown", handler);
}

/**
 * Alternative version of [`on_mouse_down`](#on_mouse_down) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mousedown_event)
 */
export function on_mouse_down_capture(handler) {
  return $attribute.attribute("onMouseDownCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mouseenter_event)
 */
export function on_mouse_enter(handler) {
  return $attribute.attribute("onMouseEnter", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mouseleave_event)
 */
export function on_mouse_leave(handler) {
  return $attribute.attribute("onMouseLeave", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mousemove_event)
 */
export function on_mouse_move(handler) {
  return $attribute.attribute("onMouseMove", handler);
}

/**
 * Alternative version of [`on_mouse_move`](#on_mouse_move) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mousemove_event)
 */
export function on_mouse_move_capture(handler) {
  return $attribute.attribute("onMouseMoveCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mouseout_event)
 */
export function on_mouse_out(handler) {
  return $attribute.attribute("onMouseOut", handler);
}

/**
 * Alternative version of [`on_mouse_out`](#on_mouse_out) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mouseout_event)
 */
export function on_mouse_out_capture(handler) {
  return $attribute.attribute("onMouseOutCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mouseup_event)
 */
export function on_mouse_up(handler) {
  return $attribute.attribute("onMouseUp", handler);
}

/**
 * Alternative version of [`on_mouse_up`](#on_mouse_up) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/mouseup_event)
 */
export function on_mouse_up_capture(handler) {
  return $attribute.attribute("onMouseUpCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointercancel_event)
 */
export function on_pointer_cancel(handler) {
  return $attribute.attribute("onPointerCancel", handler);
}

/**
 * Alternative version of [`on_pointer_cancel`](#on_pointer_cancel) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointercancel_event)
 */
export function on_pointer_cancel_capture(handler) {
  return $attribute.attribute("onPointerCancelCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointerdown_event)
 */
export function on_pointer_down(handler) {
  return $attribute.attribute("onPointerDown", handler);
}

/**
 * Alternative version of [`on_pointer_down`](#on_pointer_down) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointerdown_event)
 */
export function on_pointer_down_capture(handler) {
  return $attribute.attribute("onPointerDownCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointerenter_event)
 */
export function on_pointer_enter(handler) {
  return $attribute.attribute("onPointerEnter", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointerleave_event)
 */
export function on_pointer_leave(handler) {
  return $attribute.attribute("onPointerLeave", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointermove_event)
 */
export function on_pointer_move(handler) {
  return $attribute.attribute("onPointerMove", handler);
}

/**
 * Alternative version of [`on_pointer_move`](#on_pointer_move) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointermove_event)
 */
export function on_pointer_move_capture(handler) {
  return $attribute.attribute("onPointerMoveCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointerout_event)
 */
export function on_pointer_out(handler) {
  return $attribute.attribute("onPointerOut", handler);
}

/**
 * Alternative version of [`on_pointer_out`](#on_pointer_out) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointerout_event)
 */
export function on_pointer_out_capture(handler) {
  return $attribute.attribute("onPointerOutCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointerup_event)
 */
export function on_pointer_up(handler) {
  return $attribute.attribute("onPointerUp", handler);
}

/**
 * Alternative version of [`on_pointer_up`](#on_pointer_up) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pointerup_event)
 */
export function on_pointer_up_capture(handler) {
  return $attribute.attribute("onPointerUpCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/paste_event)
 */
export function on_paste(handler) {
  return $attribute.attribute("onPaste", handler);
}

/**
 * Alternative version of [`on_paste`](#on_paste) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/paste_event)
 */
export function on_paste_capture(handler) {
  return $attribute.attribute("onPasteCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/scroll_event)
 */
export function on_scroll(handler) {
  return $attribute.attribute("onScroll", handler);
}

/**
 * Alternative version of [`on_scroll`](#on_scroll) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/scroll_event)
 */
export function on_scroll_capture(handler) {
  return $attribute.attribute("onScrollCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/select_event)
 */
export function on_select(handler) {
  return $attribute.attribute("onSelect", handler);
}

/**
 * Alternative version of [`on_select`](#on_select) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/select_event)
 */
export function on_select_capture(handler) {
  return $attribute.attribute("onSelectCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/touchcancel_event)
 */
export function on_touch_cancel(handler) {
  return $attribute.attribute("onTouchCancel", handler);
}

/**
 * Alternative version of [`on_touch_cancel`](#on_touch_cancel) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/touchcancel_event)
 */
export function on_touch_cancel_capture(handler) {
  return $attribute.attribute("onTouchCancelCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/touchend_event)
 */
export function on_touch_end(handler) {
  return $attribute.attribute("onTouchEnd", handler);
}

/**
 * Alternative version of [`on_touch_end`](#on_touch_end) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/touchend_event)
 */
export function on_touch_end_capture(handler) {
  return $attribute.attribute("onTouchEndCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/touchmove_event)
 */
export function on_touch_move(handler) {
  return $attribute.attribute("onTouchMove", handler);
}

/**
 * Alternative version of [`on_touch_move`](#on_touch_move) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/touchmove_event)
 */
export function on_touch_move_capture(handler) {
  return $attribute.attribute("onTouchMoveCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/touchstart_event)
 */
export function on_touch_start(handler) {
  return $attribute.attribute("onTouchStart", handler);
}

/**
 * Alternative version of [`on_touch_start`](#on_touch_start) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/touchstart_event)
 */
export function on_touch_start_capture(handler) {
  return $attribute.attribute("onTouchStartCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/transitionend_event)
 */
export function on_transition_end(handler) {
  return $attribute.attribute("onTransitionEnd", handler);
}

/**
 * Alternative version of [`on_transition_end`](#on_transition_end) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/transitionend_event)
 */
export function on_transition_end_capture(handler) {
  return $attribute.attribute("onTransitionEndCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/wheel_event)
 */
export function on_wheel(handler) {
  return $attribute.attribute("onWheel", handler);
}

/**
 * Alternative version of [`on_wheel`](#on_wheel) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/wheel_event)
 */
export function on_wheel_capture(handler) {
  return $attribute.attribute("onWheelCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/reset_event)
 */
export function on_reset(handler) {
  return $attribute.attribute("onReset", handler);
}

/**
 * Alternative version of [`on_reset`](#on_reset) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/reset_event)
 */
export function on_reset_capture(handler) {
  return $attribute.attribute("onResetCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/submit_event)
 */
export function on_submit(handler) {
  return $attribute.attribute("onSubmit", handler);
}

/**
 * Alternative version of [`on_submit`](#on_submit) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/submit_event)
 */
export function on_submit_capture(handler) {
  return $attribute.attribute("onSubmitCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/cancel_event)
 */
export function on_cancel(handler) {
  return $attribute.attribute("onCancel", handler);
}

/**
 * Alternative version of [`on_cancel`](#on_cancel) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/cancel_event)
 */
export function on_cancel_capture(handler) {
  return $attribute.attribute("onCancelCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/close_event)
 */
export function on_close(handler) {
  return $attribute.attribute("onClose", handler);
}

/**
 * Alternative version of [`on_close`](#on_close) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/close_event)
 */
export function on_close_capture(handler) {
  return $attribute.attribute("onCloseCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/toggle_event)
 */
export function on_toggle(handler) {
  return $attribute.attribute("onToggle", handler);
}

/**
 * Alternative version of [`on_toggle`](#on_toggle) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/toggle_event)
 */
export function on_toggle_capture(handler) {
  return $attribute.attribute("onToggleCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/load_event)
 */
export function on_load(handler) {
  return $attribute.attribute("onLoad", handler);
}

/**
 * Alternative version of [`on_load`](#on_load) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/load_event)
 */
export function on_load_capture(handler) {
  return $attribute.attribute("onLoadCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/error_event)
 */
export function on_error(handler) {
  return $attribute.attribute("onError", handler);
}

/**
 * Alternative version of [`on_error`](#on_error) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/error_event)
 */
export function on_error_capture(handler) {
  return $attribute.attribute("onErrorCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/abort_event)
 */
export function on_abort(handler) {
  return $attribute.attribute("onAbort", handler);
}

/**
 * Alternative version of [`on_abort`](#on_abort) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/abort_event)
 */
export function on_abort_capture(handler) {
  return $attribute.attribute("onAbortCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/canplay_event)
 */
export function on_can_play(handler) {
  return $attribute.attribute("onCanPlay", handler);
}

/**
 * Alternative version of [`on_can_play`](#on_can_play) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/canplay_event)
 */
export function on_can_play_capture(handler) {
  return $attribute.attribute("onCanPlayCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/canplaythrough_event)
 */
export function on_can_play_through(handler) {
  return $attribute.attribute("onCanPlayThrough", handler);
}

/**
 * Alternative version of [`on_can_play_through`](#on_can_play_through) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/canplaythrough_event)
 */
export function on_can_play_through_capture(handler) {
  return $attribute.attribute("onCanPlayThroughCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/durationchange_event)
 */
export function on_duration_change(handler) {
  return $attribute.attribute("onDurationChange", handler);
}

/**
 * Alternative version of [`on_duration_change`](#on_duration_change) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/durationchange_event)
 */
export function on_duration_change_capture(handler) {
  return $attribute.attribute("onDurationChangeCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/emptied_event)
 */
export function on_emptied(handler) {
  return $attribute.attribute("onEmptied", handler);
}

/**
 * Alternative version of [`on_emptied`](#on_emptied) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/emptied_event)
 */
export function on_emptied_capture(handler) {
  return $attribute.attribute("onEmptiedCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/encrypted_event)
 */
export function on_encrypted(handler) {
  return $attribute.attribute("onEncrypted", handler);
}

/**
 * Alternative version of [`on_encrypted`](#on_encrypted) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/encrypted_event)
 */
export function on_encrypted_capture(handler) {
  return $attribute.attribute("onEncryptedCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/ended_event)
 */
export function on_ended(handler) {
  return $attribute.attribute("onEnded", handler);
}

/**
 * Alternative version of [`on_ended`](#on_ended) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/ended_event)
 */
export function on_ended_capture(handler) {
  return $attribute.attribute("onEndedCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/loadeddata_event)
 */
export function on_loaded_data(handler) {
  return $attribute.attribute("onLoadedData", handler);
}

/**
 * Alternative version of [`on_loaded_data`](#on_loaded_data) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/loadeddata_event)
 */
export function on_loaded_data_capture(handler) {
  return $attribute.attribute("onLoadedDataCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/loadedmetadata_event)
 */
export function on_loaded_metadata(handler) {
  return $attribute.attribute("onLoadedMetadata", handler);
}

/**
 * Alternative version of [`on_loaded_metadata`](#on_loaded_metadata) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/loadedmetadata_event)
 */
export function on_loaded_metadata_capture(handler) {
  return $attribute.attribute("onLoadedMetadataCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/loadstart_event)
 */
export function on_load_start(handler) {
  return $attribute.attribute("onLoadStart", handler);
}

/**
 * Alternative version of [`on_load_start`](#on_load_start) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/loadstart_event)
 */
export function on_load_start_capture(handler) {
  return $attribute.attribute("onLoadStartCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pause_event)
 */
export function on_pause(handler) {
  return $attribute.attribute("onPause", handler);
}

/**
 * Alternative version of [`on_pause`](#on_pause) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/pause_event)
 */
export function on_pause_capture(handler) {
  return $attribute.attribute("onPauseCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/play_event)
 */
export function on_play(handler) {
  return $attribute.attribute("onPlay", handler);
}

/**
 * Alternative version of [`on_play`](#on_play) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/play_event)
 */
export function on_play_capture(handler) {
  return $attribute.attribute("onPlayCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/playing_event)
 */
export function on_playing(handler) {
  return $attribute.attribute("onPlaying", handler);
}

/**
 * Alternative version of [`on_playing`](#on_playing) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/playing_event)
 */
export function on_playing_capture(handler) {
  return $attribute.attribute("onPlayingCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/progress_event)
 */
export function on_progress(handler) {
  return $attribute.attribute("onProgress", handler);
}

/**
 * Alternative version of [`on_progress`](#on_progress) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/progress_event)
 */
export function on_progress_capture(handler) {
  return $attribute.attribute("onProgressCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/ratechange_event)
 */
export function on_rate_change(handler) {
  return $attribute.attribute("onRateChange", handler);
}

/**
 * Alternative version of [`on_rate_change`](#on_rate_change) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/ratechange_event)
 */
export function on_rate_change_capture(handler) {
  return $attribute.attribute("onRateChangeCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/resize_event)
 */
export function on_resize(handler) {
  return $attribute.attribute("onResize", handler);
}

/**
 * Alternative version of [`on_resize`](#on_resize) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/resize_event)
 */
export function on_resize_capture(handler) {
  return $attribute.attribute("onResizeCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/seeked_event)
 */
export function on_seeked(handler) {
  return $attribute.attribute("onSeeked", handler);
}

/**
 * Alternative version of [`on_seeked`](#on_seeked) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/seeked_event)
 */
export function on_seeked_capture(handler) {
  return $attribute.attribute("onSeekedCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/seeking_event)
 */
export function on_seeking(handler) {
  return $attribute.attribute("onSeeking", handler);
}

/**
 * Alternative version of [`on_seeking`](#on_seeking) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/seeking_event)
 */
export function on_seeking_capture(handler) {
  return $attribute.attribute("onSeekingCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/stalled_event)
 */
export function on_stalled(handler) {
  return $attribute.attribute("onStalled", handler);
}

/**
 * Alternative version of [`on_stalled`](#on_stalled) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/stalled_event)
 */
export function on_stalled_capture(handler) {
  return $attribute.attribute("onStalledCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/suspend_event)
 */
export function on_suspend(handler) {
  return $attribute.attribute("onSuspend", handler);
}

/**
 * Alternative version of [`on_suspend`](#on_suspend) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/suspend_event)
 */
export function on_suspend_capture(handler) {
  return $attribute.attribute("onSuspendCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/timeupdate_event)
 */
export function on_time_update(handler) {
  return $attribute.attribute("onTimeUpdate", handler);
}

/**
 * Alternative version of [`on_time_update`](#on_time_update) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Element/timeupdate_event)
 */
export function on_time_update_capture(handler) {
  return $attribute.attribute("onTimeUpdateCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Element/volumechange_event)
 */
export function on_volume_change(handler) {
  return $attribute.attribute("onVolumeChange", handler);
}

/**
 * Alternative version of [`on_volume_change`](#on_volume_change) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Element/volumechange_event)
 */
export function on_volume_change_capture(handler) {
  return $attribute.attribute("onVolumeChangeCapture", handler);
}

/**
 * [Documentation](https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/waiting_event)
 */
export function on_waiting(handler) {
  return $attribute.attribute("onWaiting", handler);
}

/**
 * Alternative version of [`on_waiting`](#on_waiting) that runs during
 * [capture phase](https://react.dev/learn/responding-to-events#capture-phase-events). \
 * [Documentation](https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/waiting_event)
 */
export function on_waiting_capture(handler) {
  return $attribute.attribute("onWaitingCapture", handler);
}
